import { IKeHoachThucTapPhamViSinhVienActionTypes } from "../../action-types/xet-thuc-tap/IKeHoachThucTapPhamViSinhVienActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IKeHoachThucTapPhamViSinhVienReducer } from "../../reducer-model/xet-thuc-tap/IKeHoachThucTapPhamViSinhVienReducer";

const iniState: IKeHoachThucTapPhamViSinhVienReducer = {
    status: eReducerStatusBase.is_not_initialization,
    keHoachThucTapPhamViSinhViens: [],
    isHienThiTheoPhamViLop: false,
}

export const keHoachThucTapPhamViSinhVienReducer = (state: IKeHoachThucTapPhamViSinhVienReducer = iniState, action: IKeHoachThucTapPhamViSinhVienActionTypes): IKeHoachThucTapPhamViSinhVienReducer => {
    switch (action.type) {
        case "KE_HOACH_THUC_TAP_PHAM_VI_SINH_VIEN_LOAD_BY_DOT_THUC_TAP_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "KE_HOACH_THUC_TAP_PHAM_VI_SINH_VIEN_LOAD_BY_DOT_THUC_TAP_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                keHoachThucTapPhamViSinhViens: action.payload,
            };
        case "KE_HOACH_THUC_TAP_PHAM_VI_SINH_VIEN_LOAD_BY_DOT_THUC_TAP_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "KE_HOACH_THUC_TAP_PHAM_VI_SINH_VIEN_INSERTS_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "KE_HOACH_THUC_TAP_PHAM_VI_SINH_VIEN_INSERTS_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "KE_HOACH_THUC_TAP_PHAM_VI_SINH_VIEN_INSERTS_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "KE_HOACH_THUC_TAP_PHAM_VI_SINH_VIEN_DELETES_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "KE_HOACH_THUC_TAP_PHAM_VI_SINH_VIEN_DELETES_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "KE_HOACH_THUC_TAP_PHAM_VI_SINH_VIEN_DELETES_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "KE_HOACH_THUC_TAP_PHAM_VI_SINH_VIEN_CHANGE_IS_HIEN_THI_THEO_PHAM_VI_LOP":
            return {
                ...state,
                isHienThiTheoPhamViLop: action.payload,
            };
        default:
            return state;
    }
}